module.exports = __webpack_public_path__ + "static/img/10.db8c0524.png";